import styled from 'styled-components';

import { breakpoints, colors, fontFamily, zIndex } from '../../ui/variables';

export const AddExamSerieStyle = styled.div`
  @media (min-width: ${breakpoints.hd.width}px) {
    display: flex;
    justify-content: space-between;
  }

  .exam-serie-container {
    background-color: ${colors.lightGrayishBlue};
    border-radius: 8px;
    margin: 0 auto 12px;
    max-width: 100px;
    overflow: hidden;

    @media (min-width: ${breakpoints.hd.width}px) {
      margin: 0;
      max-height: 72px;
      max-width: auto;
      min-width: 100px;
    }

    .show-serie-image-modal {
      background-color: ${colors.black};
      display: block;
      height: 100%;
      position: relative;
      width: 100%;

      .serie-first-image {
        display: block;
        height: auto;
        width: 100%;

        @media (min-width: ${breakpoints.hd.width}px) {
          height: auto;
          margin: 0 auto;
          max-height: 100%;
          max-width: 100%;
          width: auto;
        }
      }

      .icon {
        bottom: 8px;
        height: 12px;
        position: absolute;
        right: 8px;
        width: 12px;

        svg {
          display: block;
          fill: ${colors.white};
          height: auto;
          width: 100%;
        }
      }
    }

    .serie-image-loading {
      max-height: 72px;
      padding: 16px;

      .loading-wrapper {
        display: block;
        margin: 0 auto;
        width: 40px;

        svg {
          animation: rotate 800ms infinite linear;
          display: block;
          fill: ${colors.softBlue};
          height: auto;
          width: 100%;
        }
      }
    }
  }

  .serie-informations {
    border: solid 1px ${colors.softBlue};
    border-radius: 8px;
    padding: 16px 12px;

    @media (min-width: ${breakpoints.hd.width}px) {
      align-items: center;
      display: flex;
      justify-content: space-between;
      margin-left: 24px;
      width: 100%;
    }

    .serie-description,
    .serie-date,
    .serie-images-count,
    .serie-images-status {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.softBlue};
      font-size: 14px;
      line-height: 18px;

      &:not(:last-child) {
        margin-bottom: 8px;

        @media (min-width: ${breakpoints.hd.width}px) {
          margin-bottom: 0;
          padding-right: 16px;
        }
      }
    }

    .serie-images-status {
      &.uploaded {
        color: ${colors.limeGreen};
      }

      &.uploading {
        color: ${colors.lightOrange};
      }
    }
  }

  .delete-exam-serie-button {
    margin-left: 24px;
    width: 20px;

    &:disabled {
      svg {
        fill: ${colors.grayishBlue};
      }
    }

    svg {
      fill: ${colors.softBlue};
      display: block;
    }
  }

  .serie-image-modal-container {
    display: flex;
    flex-wrap: nowrap;
    height: 82.4vh;
    max-height: 890px;
    max-width: 1516px;
    padding: 36px 40px;
    width: 79vw;

    .image-modal-navigation {
      height: 100%;
      margin-right: 104px;
      overflow: hidden;
      width: 144px;

      .modal-navigation-item {
        padding-top: 28px;
        transition: transform 600ms;
        width: 100%;

        &:first-child {
          padding-top: 0;
        }

        &.active {
          .navigation-item-button {
            border: solid 4px ${colors.softBlue};
          }
        }

        .navigation-item-text {
          ${fontFamily.sourceSansPro.regular};
          color: ${colors.veryDarkGrayishBlue};
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 16px;
        }

        .navigation-item-button {
          background-color: ${colors.black};
          border: solid 4px ${colors.black};
          border-radius: 6px;
          display: block;
          height: 92px;
          overflow: hidden;
          padding: 4px;
          transition: background-color 300ms;
          width: 100%;

          .item-button-image {
            display: block;
            height: auto;
            margin: 0 auto;
            max-height: 100%;
            max-width: 100%;
            width: auto;
          }
        }
      }
    }

    .image-modal-carousel {
      border-radius: 14px;
      display: block;
      height: 100%;
      max-width: calc(100% - 144px - 104px);
      min-width: calc(100% - 144px - 104px);
      overflow: hidden;
      position: relative;

      .modal-carousel-navigation-step {
        ${zIndex.hills};
        background-color: ${colors.veryDarkGrayishBlue};
        bottom: 0;
        position: absolute;
        top: 0;
        width: 80px;

        &.last-image {
          left: 0;

          .icon {
            transform: translate(-50%, -50%) rotate(90deg);
          }
        }

        &.next-image {
          right: 0;

          .icon {
            transform: translate(-50%, -50%) rotate(-90deg);
          }
        }

        &:disabled {
          .icon {
            opacity: 0.3;
          }
        }

        .icon {
          display: block;
          height: 20px;
          left: 50%;
          position: absolute;
          top: 50%;
          width: 20px;

          svg {
            display: block;
            width: 100%;
            height: auto;
            fill: ${colors.grayishBlue};
          }
        }
      }

      .modal-carousel-content {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;

        .carousel-content-item {
          align-items: center;
          background-color: ${colors.black};
          display: flex;
          height: 100%;
          justify-content: center;
          max-width: 100%;
          min-width: 100%;
          padding: 0 80px;

          .content-item-image {
            display: block;
            height: auto;
            max-height: 100%;
            max-width: 100%;
            width: auto;
          }
        }
      }
    }
  }
`;
